import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import Util from '../../util/Util';
import EmailConfigurationAPI from '../../api/EmailConfigurationAPI';
import withRouter from '../../util/WithRouter';

class EmailConfigurationUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      inApiCall: true, id: '', name: '', type: 1,
      host: '', port: '', secure: 0, username: '', password: ''
    };

    this.id = parseInt(props.match.params.emailConfigId);

    this.base = this.props.match.path;
    this.base = this.base.substring(0, this.base.indexOf('/add-edit'));

    this.key = 'mass-email';
  }

  componentDidMount() {
    if (this.id !== 0) {
      this.setState({ ...this.state, id: this.id });
      EmailConfigurationAPI.get(this.id, this.onReceived, this.onFail);
    } else { this.setState({ ...this.state, id: 0 }); }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => {
    this.setState({ ...res });
  };

  onChange = (field, val) => {
    const state = { ...this.state };
    if (field.includes('.')) {
      const fields = field.split('.');
      state[fields[0]][fields[1]] = val;
    } else state[field] = val;
    this.setState({ ...state });
  };

  onSave = () => {
    let state = { ...this.state };
    EmailConfigurationAPI.save(state, this.onUpdateReceived, this.onFail);
  };

  onUpdateReceived = res => this.props.navigate(`${this.base}`);

  render() {

    return (
      <div className="sectionform pt-4">
        <div className="container form-cont">
          <div className="row">
            <div className="col-md-12">
              <h3 className="pb-3">Email Configuration</h3>
            </div>
          </div>

          {/* <ApiUiController inApiCall={this.state.inApiCall}> */}
          <Form className="row row-cols-3 lead-form">
            <div className="col">
              <div className="form-group">
                <label>Name</label>
                <FormControl type="text" value={this.state.name} className="mr-sm-2"
                  onChange={event => this.onChange('name', event.target.value)} />
              </div>
            </div>

            <div className="col">
              <div className="form-group">
                <label>From Mail</label>
                <FormControl type="text" value={this.state.from_mail} className="mr-sm-2"
                  onChange={event => this.onChange('from_mail', event.target.value)} />
              </div>
            </div>

            <div className="col">
              <div className="form-group">
                <label>Host</label>
                <FormControl type="text" value={this.state.host} className="mr-sm-2"
                  onChange={event => this.onChange('host', event.target.value)} />
              </div>
            </div>

            <div className="col">
              <div className="form-group">
                <label>Port</label>
                <FormControl type="number" value={this.state.port} className="mr-sm-2"
                  onChange={event => this.onChange('port', event.target.value)} />
              </div>
            </div>

            <div className="col">
              <div className="form-group">
                <label>Secure</label>
                <div className="inline-formcheck">
                  <Form.Check onChange={() => this.onChange('secure', 1)}
                    checked={this.state.secure} /> <label class="marginlab">Yes</label>
                  <Form.Check onChange={() => this.onChange('secure', 0)}
                    checked={!this.state.secure} /> <label>No</label>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="form-group">
                <label>Username</label>
                <FormControl type="text" value={this.state.username} className="mr-sm-2"
                  onChange={event => this.onChange('username', event.target.value)} />
              </div>
            </div>

            <div className="col">
              <div className="form-group">
                <label>Password</label>
                <FormControl type="password" value={this.state.password} className="mr-sm-2"
                  onChange={event => this.onChange('password', event.target.value)} />
              </div>
            </div>

            <div className="col-md-12 text-center btnsend pt-4">
              <Button variant="success" onClick={this.onSave}>Save</Button>
            </div>
          </Form>
          {/* </ApiUiController> */}
        </div>
      </div>
    );
  }
}
export default withRouter(EmailConfigurationUpdate);